"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGroupedSetDiff = void 0;
var utils_1 = require("../../../utils");
var IGroupedSetDiff = function (_a) {
    var deleted = _a.deleted, added = _a.added, updated = _a.updated;
    return (0, utils_1.IMap)([
        ['deleted', deleted !== null && deleted !== void 0 ? deleted : (0, utils_1.ISet)()],
        ['added', added !== null && added !== void 0 ? added : (0, utils_1.ISet)()],
        ['updated', updated !== null && updated !== void 0 ? updated : (0, utils_1.ISet)()]
    ]);
};
exports.IGroupedSetDiff = IGroupedSetDiff;
